import styled from 'styled-components';

import { useIsMobile } from '@hooks/use-is-mobile';
import { theme } from '@styles/theme';

import { Loading } from 'components/Loading';

export default function PlaceholderPage() {
  const isMobile = useIsMobile();
  if (isMobile) return null;
  return (
    <Container>
      <Side />
      <Header />
      <Loading />
    </Container>
  );
}

const Header = styled.div((p) => ({
  backgroundColor: p.theme.colors.white100,
  height: '5.5rem',
  width: '100%',
}));

const Side = styled.div({
  position: 'absolute',
  left: 0,
  top: 0,
  bottom: 0,
  height: '100%',
  minWidth: '5.5rem',
  backgroundColor: theme.color.purple10,
});

const Container = styled.div((p) => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  backgroundColor: theme.color.purple5,
}));
